import { Link } from "wouter";
import Layout from "@/components/Layout";
import { useSEO } from "@/hooks/useSEO";
import { BLOG_YAZILARI } from "@/lib/blog_data";
import { Calendar, Clock, ArrowRight, BookOpen } from "lucide-react";

export default function Blog() {
  useSEO({
    title: "Blog — Reklam Hesabı, Meta & Google Ads Rehberleri | AdsManager",
    description:
      "Reklam hesabı kapanmaları, ajans hesapları, harcama limitleri ve Meta/Google reklam yönetimi üzerine uzman rehberler. AdsManager ekibinden pratik, uygulanabilir içerikler.",
    canonical: "https://adsmanager.com.tr/blog",
  });

  return (
    <Layout>
      <section className="bg-[#FFFDF7] border-b-3 border-[#0A1A3F]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
          <div className="inline-flex items-center gap-2 border-3 border-[#0A1A3F] bg-[#6B8AFE]/10 px-4 py-2 mb-6 shadow-[2px_2px_0_0_#0A1A3F]">
            <BookOpen className="w-4 h-4 text-[#6B8AFE]" />
            <span className="text-xs font-bold text-[#0A1A3F] uppercase tracking-wider">ADSMANAGER BLOG</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#0A1A3F] tracking-tight mb-4 break-words">
            Reklam Yönetimi Rehberleri
          </h1>
          <p className="text-base text-[#0A1A3F]/70 font-medium max-w-2xl leading-relaxed">
            Reklam hesabı kapanmaları, ajans hesapları, harcama limitleri ve performans pazarlaması
            üzerine sahadan gelen, uygulanabilir içerikler.
          </p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {BLOG_YAZILARI.map(yazi => (
            <Link
              key={yazi.slug}
              href={`/blog/${yazi.slug}`}
              className="group bg-[#FFFDF7] border-3 border-[#0A1A3F] p-5 sm:p-6 shadow-[4px_4px_0_0_#0A1A3F] hover:shadow-[6px_6px_0_0_#6B8AFE] hover:-translate-y-0.5 transition-all flex flex-col min-w-0"
            >
              <span className="inline-block self-start bg-[#6B8AFE] text-white border-2 border-[#0A1A3F] px-2.5 py-1 text-xs font-bold uppercase tracking-wider mb-4 shadow-[2px_2px_0_0_#0A1A3F]">
                {yazi.category}
              </span>
              <h2 className="text-lg sm:text-xl font-black text-[#0A1A3F] leading-snug mb-3 group-hover:text-[#6B8AFE] transition-colors break-words">
                {yazi.title}
              </h2>
              <p className="text-sm text-[#0A1A3F]/60 font-medium leading-relaxed mb-5 flex-grow">{yazi.summary}</p>
              <div className="flex items-center justify-between gap-3 border-t-2 border-[#0A1A3F]/10 pt-4">
                <div className="flex items-center flex-wrap gap-x-4 gap-y-1 text-xs font-bold text-[#0A1A3F]/50">
                  <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" />{yazi.date}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{yazi.readTime}</span>
                </div>
                <ArrowRight className="w-4 h-4 flex-shrink-0 text-[#6B8AFE] group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </Layout>
  );
}
